import React, { Component } from 'react'
import CommonHeader from '../../navbars/CommonHeader';

// Analysis page header: the shared CommonHeader, in a colour of its own
// (page styles from .questiontypeNavbar-nav).
class QuestionTypeNavbar extends Component {
    render() {
        return (
            <CommonHeader className="questiontypeNavbar-nav" color="auto" tone="light" container={false} onToggleSidebar={this.props.onClick} title={"Question Type"} />
        )
    }
}

export default QuestionTypeNavbar;
